import {
  Descriptions,
  Button,
  DatePicker,
  Form,
  PageHeader,
  Row,
  Select,
  Radio,
  Breadcrumb,
  Popconfirm,
  Col,
  Input,
  message,
  Spin,
  Table,
} from "antd";
import React, { useEffect, useState } from "react";
import Page from "_components/Page";
import TabMenu from "./TabMenu";
import { Link } from "react-router-dom";

import { stockReceiptService } from "_services";
import DescriptionsItem from "antd/lib/descriptions/Item";

const asycudaInitial = {
  id: "f24e53669d24f138f3750d2ceb848c2a",
  asycudaProperty: {
    id: "f24e53669d24f138f3750d2ceb848c2a",
    sadFlow: "I",
    numberOfTheForm: "1", //done
    totalNumberOfForms: "2", //done
    totalNumberOfItems: 2, //done
    totalNumberOfPackages: 4, //done
  },
  asycudaIdentification: {
    id: "2056a8633c03c8f753aa98d2a0348ecf",
    customsClearanceOfficeCode: "CBBD1", //done
    customsClearanceOfficeName: "Colombo Bonding Division", //done
    typeOfDeclaration: "IM", //done
    declarationGenProcedureCode: null,
    typeOfTransitDocument: "7", //done
    manifestReferenceNumber: "SECMB 2024  355", //done
    registrationSerialNumber: "S",
    registrationNumber: "3264", //done
    registrationDate: "2024-01-31",
    assessmentSerialNumber: "A",
    assessmentNumber: "4834",
    assessmentDate: "2024-01-31",
    receiptSerialNumber: "R",
    receiptNumber: "5094",
    receiptDate: "2024-02-01", //done
  },
  asycudaTraders: {
    id: "f24e53669d24f138f3750d2ceb848c2a",
    exporterCode: "\n", //done
    //done
    exporterName:
      "INX INTERNATIONAL UK LTD.\nHILLTOP ROAD HARESHILL\nDISTRIBUTION PARK HEYWOOD\nOL 10 2TW\nUNITED KINGDOM.", //done
    consigneeCode: "1749710807000", //done
    //done
    consigneeName:
      "CEYLON BEVERAGE CAN PVT LTD\n54, SARASAVI LANE, CSTLE STREET\nCOLOMBO 08\nLAX 30/06/2026\nDDC RMU ORDER", //done
    financialCode: "1749710807000", //done
    //done
    financialName:
      "CEYLON BEVERAGE CAN PVT LTD\n54, SARASAVI LANE, CSTLE STREET\nCOLOMBO 08\nLAX 30/06/2026\nDDC RMU ORDER", //done
  },
  asycudaDeclarant: {
    id: "2056a8633c03c8f753aa98d2a0348ecf",
    declarantCode: "103253047", //done
    //done
    declarantName:
      "M LINE INTERNATIONAL (PVT) LTD\nNO. 46/6, LEVEL 6, VALIANT TOWERS,\nNAWAM MAWATHA, COLOMBO 02",
    referenceNumber: null, //done
  },
  asycudaGeneralInformation: {
    id: "2056a8633c03c8f753aa98d2a0348ecf",
    countryFirstDestination: "GB", //done
    tradingCountry: "GB", //done
    exportCountryCode: "GB", //done
    exportCountryName: "United Kingdom", //done
    destinationCountryCode: "LK", //done
    destinationCountryName: "Sri Lanka", //done
    countryOfOriginName: "United Kingdom", //done
    valueDetails: "470546", //done
    cap: 0, //done
  },
  asycudaFinancial: {
    id: "2056a8633c03c8f753aa98d2a0348ecf",
    bankCode: "7010",
    bankName: "Bank of Ceylon",
    branch: "001",
    reference: "\n",
    termsCode: "70",
    termsDescription: "Open Account",
    defferedPaymentReference: null,
    totalInvoice: "",
    totalManualTax: "",
    globalTax: 550,
    totalTax: 550,
    amount: null,
    modOfPayment: "CASH",
    date: null,
    currencyCode: null,
    currencyName: null,
  },
  asycudaWarehouse: null,
  asycudaTransit: null,
  asycudaValuation: {
    id: "f24e53669d24f138f3750d2ceb848c2a",
    grossWeight: "",
    totalCost: 470546,
    totalCif: 9838751,
    totalInvoice: 28987.8,
    totalWeight: 2169.8,
    amountNationalCurrency: null,
    amountForeignCurrency: null,
    gsInvoiceAmountNationalCurrency: 9368204.73,
    gsInvoiceAmountForeignCurrency: 28987.8,
    gsInvoiceCurrencyCode: "USD",
    gsInvoiceCurrencyName: "No foreign currency",
    gsExternalFreightAmountNationalCurrency: 329964.23,
    gsExternalFreightAmountForeignCurrency: 1021,
    gsExternalFreightCurrencyName: "\n",
    gsInternalFreightAmountNationalCurrency: 0,
    gsInternalFreightAmountForeignCurrency: 0,
    gsInternalFreightCurrencyName: "No foreign currency",
    gsInsuranceAmountNationalCurrency: 140582.21,
    gsInsuranceAmountForeignCurrency: 435,
    gsInsuranceCurrencyName: "\n",
    gsOtherCostAmountNationalCurrency: 0,
    gsOtherCostAmountForeignCurrency: 0,
    gsOtherCostCurrencyName: "No foreign currency",
    gsDeductionAmountNationalCurrency: 0,
    gsDeductionAmountForeignCurrency: 0,
    gsDeductionCurrencyName: null,
  },
  asycudaContainer: null,
  asycudaItem: [
    {
      id: 30,
      materialHsCode: null,
      itemNumber: null,
      itemDescription: null,
      quantity: 0,
      unitPrice: 0,
      totalValue: 0,
    },
  ],
};

function TiepAsycuda({ history, match }) {
  const { id } = match.params;
  const [asycuda, setAsycuda] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    stockReceiptService
      //.getAsycuda("f7c568dff36d7863941666f82a610aee")
      .getAsycuda(id)
      .then((x) => {
        setAsycuda(x.content);
      })
      .catch((error) => {
        setError(error);
        console.log(error);
      });

    return setAsycuda(null);
  }, []);

  const headerItems = [
    {
      key: "1",
      label: <b>Delaration</b>,

      children: (
        <p>
          {asycuda?.asycudaIdentification.typeOfDeclaration}{" "}
          {asycuda?.asycudaIdentification.typeOfTransitDocument}
        </p>
      ),
    },

    {
      key: "2",
      label: <b>Customs Reference Number</b>,

      children: (
        <p>
          {asycuda?.asycudaIdentification.registrationSerialNumber}{" "}
          <span>{asycuda?.asycudaIdentification.registrationNumber}</span>{" "}
        </p>
      ),
    },

    {
      key: "3",
      label: <b>Manifest</b>,

      children: <p>{asycuda?.asycudaIdentification.manifestReferenceNumber}</p>,
    },
    {
      key: "99999",
      label: <b>Recipt Date</b>,

      children: <p>{asycuda?.asycudaIdentification.receiptDate}</p>,
    },
    {
      key: "2",
      label: <b>Customs Clearance Office</b>,
      span: "2",
      children: (
        <p>
          {asycuda?.asycudaIdentification.customsClearanceOfficeName} (
          {asycuda?.asycudaIdentification.customsClearanceOfficeCode} ){" "}
        </p>
      ),
    },
    {
      key: "4",
      label: <b>Forms</b>,

      children: (
        <p>
          {asycuda?.asycudaProperty.numberOfTheForm} |{" "}
          {asycuda?.asycudaProperty.totalNumberOfForms}
        </p>
      ),
    },
    {
      key: "4",
      label: <b>Items</b>,

      children: <p>{asycuda?.asycudaProperty.totalNumberOfItems} </p>,
    },

    {
      key: "4",
      label: <b>Total packages</b>,

      children: <p>{asycuda?.asycudaProperty.totalNumberOfPackages} </p>,
    },
    {
      key: "1",
      span: "2",
      label: <b>Exporter</b>,

      children: <p>{asycuda?.asycudaTraders.exporterName}</p>,
    },
    {
      key: "2",
      label: <b>TIN</b>,
      span: "filled",
      children: asycuda?.asycudaTraders.exporterCode.length > 3 ?? "",
    },
    {
      key: "3",
      label: <b>Consignee</b>,
      span: "2",
      children: asycuda?.asycudaTraders.consigneeName,
    },
    {
      key: "4",
      label: <b>TIN</b>,
      span: "filled",
      children: asycuda?.asycudaTraders.consigneeCode,
    },
    {
      key: "5",
      label: <b>Declarant/Representativ</b>,
      span: "2",
      children: asycuda?.asycudaDeclarant.declarantName,
    },
    {
      key: "6",
      label: <b>TIN</b>,
      span: "filled",
      children: asycuda?.asycudaDeclarant.declarantCode,
    },
    {
      key: "5",
      label: <b>Financial Settlement</b>,
      span: "2",
      children: asycuda?.asycudaTraders.financialName,
    },
    {
      key: "6",
      label: "TIN",
      span: "filled",
      children: asycuda?.asycudaTraders.financialCode,
    },

    {
      key: "5",
      label: <b>First Destination Country Code</b>,

      children: asycuda?.asycudaGeneralInformation.countryFirstDestination,
    },
    {
      key: "6",
      label: <b>Trading Country Code</b>,

      children: asycuda?.asycudaGeneralInformation.tradingCountry,
    },
    {
      key: "5",
      label: <b>Value Details</b>,

      children: asycuda?.asycudaGeneralInformation.valueDetails.num,
    },
    {
      key: "6",
      label: <b>C.A.P</b>,
      span: "filled",
      children: asycuda?.asycudaGeneralInformation.cap,
    },
    {
      key: "6",
      label: <b>Country of Export</b>,

      children: (
        <p>
          {" "}
          {asycuda?.asycudaGeneralInformation.exportCountryName} ({" "}
          {asycuda?.asycudaGeneralInformation.exportCountryCode} ){" "}
        </p>
      ),
    },
    {
      key: "6",
      label: <b>Country of Origin</b>,

      children: (
        <p>
          {" "}
          {asycuda?.asycudaGeneralInformation.countryOfOriginName} ({" "}
          {asycuda?.asycudaGeneralInformation.countryFirstDestination} ){" "}
        </p>
      ),
    },
    {
      key: "6",
      label: <b>Country of Destination</b>,

      children: (
        <p>
          {" "}
          {asycuda?.asycudaGeneralInformation.destinationCountryName} ({" "}
          {asycuda?.asycudaGeneralInformation.destinationCountryCode} ){" "}
        </p>
      ),
    },

    {
      key: "6",
      label: <b>Currency</b>,

      children: <p> {asycuda?.asycudaValuation.gsInvoiceCurrencyCode} </p>,
    },

    {
      key: "6",
      label: <b>Total Invoiced Amount</b>,

      children: (
        <CurrencyFormatter
          value={asycuda?.asycudaValuation?.gsInvoiceAmountForeignCurrency}
        />
      ),
    },

    {
      key: "6",
      label: <b>Total Invoiced Amount(LKR)</b>,

      children: (
        <CurrencyFormatter
          value={asycuda?.asycudaValuation?.gsInvoiceAmountNationalCurrency}
        />
      ),
    },

    {
      key: "6",
      label: <b>Terms of payment</b>,

      children: <p> {asycuda?.asycudaFinancial?.termsCode} </p>,
    },

    {
      key: "6",
      label: <b>Terms Description</b>,

      children: <p> {asycuda?.asycudaFinancial?.termsDescription} </p>,
    },

    {
      key: "6",
      label: <b>Bank Code</b>,

      children: <p> {asycuda?.asycudaFinancial?.bankCode} </p>,
    },

    {
      key: "6",
      label: <b>Bank Name</b>,

      children: <p> {asycuda?.asycudaFinancial?.bankName} </p>,
    },

    {
      key: "6",
      label: <b>Bank Branch</b>,

      children: <p> {asycuda?.asycudaFinancial.branch} </p>,
    },

    {
      key: "6",
      label: <b>Ref no.</b>,

      children: <p> {asycuda?.asycudaFinancial.reference} </p>,
    },
  ];

  const headerStyle = { color: "White", backgroundColor: "Grey" };

  const getDescriptionHeader = (title) => <h2 style={headerStyle}> {title}</h2>;

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/stock-receipts">Stock Receipts Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Asycude Viewer</Breadcrumb.Item>
          </Breadcrumb>
        }
      >
        <Page>
          <TabMenu menu="asycuda" id={id} />
          {asycuda && (
            <Descriptions
              title={getDescriptionHeader("Header Information")}
              bordered
            >
              {headerItems.map((item) => (
                <Descriptions.Item span={item.span ?? "1"} label={item.label}>
                  {item.children}
                </Descriptions.Item>
              ))}
            </Descriptions>
          )}
          {asycuda?.asycudaItem.map((item, index) => (
            <ItemsInformation
              title={getDescriptionHeader("Package " + index + 1)}
              item={item}
            />
          ))}
        </Page>
      </PageHeader>
    </div>
  );
}

export default TiepAsycuda;

const demoPackageItem = {
  id: 30,
  materialHsCode: null, //done
  itemNumber: null, //done
  itemDescription: null, //done
  quantity: 0,
  unitPrice: 0, //done
  totalValue: 0,
  numberOfPackages: null, //done
  marksOfPackages: null, //done
  marks2OfPackages: null,
  kindOfPackageCode: null, //done
  kindOfPackageName: null, //done
  incoTerms: null,
  grossWeight: null, //done
  netWeight: null, //done
  countryOfOrigin: null,
  itemTaxesAmount: null,
  itemTaxesGuarantedAmount: null,
  itemTaxesModeOfPayment: null,
  asycudaItemTaxationLine: [],
};

//format the text as a decimal or can use as a currency with changing the style to currency and add currency parametre
const CurrencyFormatter = ({ value, locale = "en-US" }) => {
  const formattedValue = new Intl.NumberFormat(locale, {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

  return <span>{formattedValue}</span>;
};

// Utility function to check for empty values
const isValueEmpty = (value) => {
  return value == null || value.trim() === "";
};

function ItemsInformation({ item, title }) {
  const pakageItems = [
    {
      key: "1",
      label: <b>Item No</b>,

      children: <p>{item.itemNumber}</p>,
    },
    {
      key: "2",
      label: <b>Material Hscode</b>,

      children: <p>{item.materialHsCode}</p>,
    },
    {
      key: "3",
      label: <b>Country Of Origin</b>,

      children: <p>{item.countryOfOrigin}</p>,
    },

    {
      key: "4",
      label: <b>Material Description</b>,

      children: <p>{item.itemDescription}</p>,
    },
    {
      key: "5",
      label: <b>Marks & Nos of Packages:</b>,

      children: <p>{item.marks2OfPackages}</p>,
    },

    {
      key: "6",
      label: <b>Number & Kind:</b>,

      children: (
        <p>
          {item.kindOfPackageName}({item.kindOfPackageCode})
        </p>
      ),
    },

    {
      key: "7",
      label: <b>Net Mass (Kg):</b>,

      children: <p>{item.netWeight}</p>,
    },
    {
      key: "8",
      label: <b>Gross Mass (Kg):</b>,

      children: <p>{item.grossWeight}</p>,
    },
    {
      key: "9",
      label: <b>Item Price(FOB/CIF):</b>,

      children: <p>{item.unitPrice}</p>,
    },

    {
      key: "10",
      label: <b>Total Price:</b>,

      children: <p>{item.totalValue}</p>,
    },
  ];

  const Taxcolumns = [
    {
      title: "Type",
      dataIndex: "dutyTaxCode",
      key: "Type",
      render: (value) => (isValueEmpty(value) ? null : value), // Use the utility function
    },
    {
      title: "Tax Base",
      dataIndex: "dutyTaxBase",
      key: "Base",
      render: (value) =>
        value.length > 1 ? <CurrencyFormatter value={value} /> : null,
    },
    {
      title: "Rate",
      dataIndex: "dutyTaxRate",
      key: "Rate",
      render: (value) => (isValueEmpty(value) ? null : value), // Use the utility function
    },
    {
      title: "Amount",
      dataIndex: "dutyTaxAmount",
      key: "Amount",
      render: (value) =>
        value.length > 3 ? <CurrencyFormatter value={value} /> : null,
    },
  ];

  return (
    <>
      <Descriptions title={title} bordered>
        {pakageItems.map((item) => (
          <Descriptions.Item span={item.span ?? "1"} label={item.label}>
            {item.children}
          </Descriptions.Item>
        ))}
      </Descriptions>
      <Table
        columns={Taxcolumns}
        dataSource={item?.asycudaItemTaxationLine ?? []}
        summary={(pageData) => {
          console.log(pageData);

          // Convert string values to numbers and sum them
          const totalAmount = pageData.reduce((sum, row) => {
            const amount = parseFloat(row.dutyTaxAmount); // Convert string to number
            return sum + (isNaN(amount) ? 0 : amount); // Skip invalid numbers
          }, 0);

          return (
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={3}>
                <strong>Total</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1}>
                <CurrencyFormatter value={totalAmount} />
              </Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }}
      />
    </>
  );
}
